import React from "react";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { deriveValidationProblems, validators } from "pages/dashboard/admin/import/interest_imports/components/utils";
import { Problem, verifyDateOrder } from "pages/dashboard/admin/import/interest_imports/validate";
import ValidationsV2 from "pages/dashboard/admin/import/interest_imports/components/validations-v2";
import { StepData, StepProps } from "..";
import { useStepData } from "../context";
import StepLayout from "./layout";
import { validateStep } from "./validation";

const StepErrors: React.FC<StepProps> = () => {
  const { stepData, setStepData, setStepName } = useStepData();
  const navigate = useNavigate();
  if (!validateStep(stepData, "errors")) {
    return null;
  }

  const setProblems = (problems: Problem[]) => {
    setStepData((prevData: StepData) => ({ ...prevData, problems }));
  };

  const orderValidation = stepData.validateOrder;
  React.useEffect(() => {
    const currentValidators = validators.concat(orderValidation ? [verifyDateOrder] : []);
    const calculatedProblems = deriveValidationProblems(currentValidators, stepData);
    // If no problems on initial load -> go to next step:
    if (calculatedProblems.length === 0) {
      setStepData((prevData: StepData) => ({ ...prevData, step: "Finalize", problems: [] }));
      navigate("/dash/manager/settings/imports/finalize", { replace: true });
    } else {
      setProblems(calculatedProblems);
    }
  }, [stepData.data, stepData.mapping, stepData.validateOrder]);

  React.useEffect(() => {
    setStepName("Errors");
  }, []);


  return <StepLayout
    title="Validate your data"
    description={<Typography variant="body1">
      To ensure all key application information is correct, we validate your spreadsheet data.
    </Typography>}
  >
    <ValidationsV2 problems={stepData.problems} />
  </StepLayout>;
};

export default StepErrors;
